<template>
  <v-container fluid class="ma-0 pa-0" id="app" v-scroll-spy="{data: 'section'}">
    <v-row class="ma-0 pa-0 hero">
      <v-col class="ma-0 pa-0">
        <Hero />
      </v-col>
    </v-row>

    <v-row class="ma-0 pa-0">
      <v-col class="ma-0 pa-0">
        <About />
      </v-col>
    </v-row>

    <v-row class="ma-0 pa-0 services">
      <v-col class="ma-0 pa-0">
        <Services />
      </v-col>
    </v-row>

    <v-row class="ma-0 pa-0 skills">
      <v-col cols="12" class="top-skills" />

      <v-col class="ma-0 pa-0">
        <Skills />
      </v-col>

      <v-col cols="12" class="bot-skills" />
    </v-row>

    <v-row class="ma-0 pa-0 experience">
      <v-col class="ma-0 pa-0">
        <Experiences />
      </v-col>
    </v-row>

    <v-row class="ma-0 pa-0 portfolio">
      <svg
        id="bigTriangleColor"
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        width="100%"
        height="100"
        viewBox="0 0 100 102"
        preserveAspectRatio="none"
      >
        <path d="M0 0 L50 100 L100 0 Z" />
      </svg>

      <v-col class="ma-0 pa-0">
        <Portfolio />
      </v-col>
    </v-row>

    <!--<v-row class="ma-0 pa-0">
      <v-col class="ma-0 pa-0">
        <Pricing />
      </v-col>
    </v-row>-->

    <!-- <v-row class="ma-0 pa-0">
      <v-col class="ma-0 pa-0">
        <Blog />
      </v-col>
    </v-row> -->

    <v-row class="ma-0 pa-0">
      <v-col class="ma-0 pa-0">
        <Contact />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Hero from "./home/Hero";
import About from "./home/About";
import Services from "./home/Services";
import Skills from "./home/Skills";
import Experiences from "./home/Experiences";
import Portfolio from "./home/Portfolio";
// import Pricing from './home/Pricing'
// import Blog from './home/Blog'
import Contact from "./home/Contact";

export default {
  components: {
    Hero,
    About,
    Services,
    Skills,
    Experiences,
    Portfolio,
    // Pricing,
    // Blog,
    Contact
  },
  data: () => {
    return {
      section: 0
    }
  }
};
</script>

<style scoped>
.hero {
  background: linear-gradient(
      40deg,
      rgba(0, 0, 0, 0) 20%,
      rgba(0, 0, 0, 0.2) 0%
    ),
    white;
}
.services {
  background: linear-gradient(
      15deg,
      rgba(0, 0, 0, 0) 80%,
      rgba(0, 0, 0, 0.1) 80.2%
    ),
    rgba(26, 188, 156);
}

.transition-services-to-skills {
  height: 18vh;
  background: linear-gradient(
      4deg,
      rgba(112, 123, 255) 50%,
      rgba(0, 0, 0, 0) 50.5%
    ),
    linear-gradient(2deg, rgba(0, 0, 0, 0.1) 70%, rgba(0, 0, 0, 0) 70.5%),
    rgba(26, 188, 156);
}

.top-skills {
  background: linear-gradient(
      4deg,
      rgb(0, 0, 0, 0) 60%,
      rgba(26, 188, 156) 60.5%
    ),
    linear-gradient(5deg, rgb(0, 0, 0, 0) 50%, rgba(0, 0, 0, 0.1) 50.5%);
  height: 20vh;
}
.skills {
  background: url("/img/design-bg.jpg") center center;
  background-size: cover;
}
.bot-skills {
  height: 20vh;
  background:linear-gradient(
      175deg,
      rgba(0, 0, 0, 0) 50%,
      rgba(79, 179, 108) 50.5%
    );
}

.transition-skills-to-experience {
  height: 20vh;
  background: linear-gradient(
      175deg,
      rgba(0, 0, 0, 0) 50%,
      rgba(79, 179, 108) 50.5%
    ),
    linear-gradient(177deg, rgba(0, 0, 0, 0) 40%, rgba(0, 0, 0, 0.1) 40.5%),
    rgba(112, 123, 255);
}

.experience {
  background: rgba(79, 179, 108);
}

svg#bigTriangleColor {
  pointer-events: none;
}

#bigTriangleColor path {
  fill: rgba(79, 179, 108);
}

/*.portfolio {
  min-height: 80vh;
  background: rgba(255, 212, 150);
}*/
.portfolio {
  min-height: 80vh;
  background: url('/img/diag-bg.jpg');
  background-size: cover;
}
</style>
